/* global $ */

$(document).ready(() => {
  /* eslint-disable */
  !(function(e, n, t) {
    function r(e, n) {
      return typeof e === n;
    }
    function s() {
      var e, n, t, s, o, i, l;
      for (var a in S)
        if (S.hasOwnProperty(a)) {
          if (
            ((e = []),
            (n = S[a]),
            n.name &&
              (e.push(n.name.toLowerCase()),
              n.options && n.options.aliases && n.options.aliases.length))
          )
            for (t = 0; t < n.options.aliases.length; t++)
              e.push(n.options.aliases[t].toLowerCase());
          for (
            s = r(n.fn, 'function') ? n.fn() : n.fn, o = 0;
            o < e.length;
            o++
          )
            (i = e[o]),
              (l = i.split('.')),
              1 === l.length
                ? (Modernizr[l[0]] = s)
                : (!Modernizr[l[0]] ||
                    Modernizr[l[0]] instanceof Boolean ||
                    (Modernizr[l[0]] = new Boolean(Modernizr[l[0]])),
                  (Modernizr[l[0]][l[1]] = s)),
              C.push((s ? '' : 'no-') + l.join('-'));
        }
    }
    function o(e) {
      var n = _.className,
        t = Modernizr._config.classPrefix || '';
      if ((x && (n = n.baseVal), Modernizr._config.enableJSClass)) {
        var r = new RegExp('(^|\\s)' + t + 'no-js(\\s|$)');
        n = n.replace(r, '$1' + t + 'js$2');
      }
      Modernizr._config.enableClasses &&
        ((n += ' ' + t + e.join(' ' + t)),
        x ? (_.className.baseVal = n) : (_.className = n));
    }
    function i() {
      return 'function' != typeof n.createElement
        ? n.createElement(arguments[0])
        : x
          ? n.createElementNS.call(
              n,
              'http://www.w3.org/2000/svg',
              arguments[0],
            )
          : n.createElement.apply(n, arguments);
    }
    function l(e, n) {
      return !!~('' + e).indexOf(n);
    }
    function a(e) {
      return e
        .replace(/([a-z])-([a-z])/g, function(e, n, t) {
          return n + t.toUpperCase();
        })
        .replace(/^-/, '');
    }
    function u(e, n) {
      return function() {
        return e.apply(n, arguments);
      };
    }
    function f(e, n, t) {
      var s;
      for (var o in e)
        if (e[o] in n)
          return t === !1
            ? e[o]
            : ((s = n[e[o]]), r(s, 'function') ? u(s, t || n) : s);
      return !1;
    }
    function p(n, t, r) {
      var s;
      if ('getComputedStyle' in e) {
        s = getComputedStyle.call(e, n, t);
        var o = e.console;
        if (null !== s) r && (s = s.getPropertyValue(r));
        else if (o) {
          var i = o.error ? 'error' : 'log';
          o[i].call(
            o,
            'getComputedStyle returning null, its possible modernizr test results are inaccurate',
          );
        }
      } else s = !t && n.currentStyle && n.currentStyle[r];
      return s;
    }
    function c(e) {
      return e
        .replace(/([A-Z])/g, function(e, n) {
          return '-' + n.toLowerCase();
        })
        .replace(/^ms-/, '-ms-');
    }
    function d() {
      var e = n.body;
      return e || ((e = i(x ? 'svg' : 'body')), (e.fake = !0)), e;
    }
    function m(e, t, r, s) {
      var o,
        l,
        a,
        u,
        f = 'modernizr',
        p = i('div'),
        c = d();
      if (parseInt(r, 10))
        for (; r--; )
          (a = i('div')), (a.id = s ? s[r] : f + (r + 1)), p.appendChild(a);
      return (
        (o = i('style')),
        (o.type = 'text/css'),
        (o.id = 's' + f),
        (c.fake ? c : p).appendChild(o),
        c.appendChild(p),
        o.styleSheet
          ? (o.styleSheet.cssText = e)
          : o.appendChild(n.createTextNode(e)),
        (p.id = f),
        c.fake &&
          ((c.style.background = ''),
          (c.style.overflow = 'hidden'),
          (u = _.style.overflow),
          (_.style.overflow = 'hidden'),
          _.appendChild(c)),
        (l = t(p, e)),
        c.fake
          ? (c.parentNode.removeChild(c),
            (_.style.overflow = u),
            _.offsetHeight)
          : p.parentNode.removeChild(p),
        !!l
      );
    }
    function y(n, r) {
      var s = n.length;
      if ('CSS' in e && 'supports' in e.CSS) {
        for (; s--; ) if (e.CSS.supports(c(n[s]), r)) return !0;
        return !1;
      }
      if ('CSSSupportsRule' in e) {
        for (var o = []; s--; ) o.push('(' + c(n[s]) + ':' + r + ')');
        return (
          (o = o.join(' or ')),
          m(
            '@supports (' + o + ') { #modernizr { position: absolute; } }',
            function(e) {
              return 'absolute' == p(e, null, 'position');
            },
          )
        );
      }
      return t;
    }
    function v(e, n, s, o) {
      function u() {
        p && (delete k.style, delete k.modElem);
      }
      if (((o = r(o, 'undefined') ? !1 : o), !r(s, 'undefined'))) {
        var f = y(e, s);
        if (!r(f, 'undefined')) return f;
      }
      for (
        var p, c, d, m, v, g = ['modernizr', 'tspan', 'samp'];
        !k.style && g.length;

      )
        (p = !0), (k.modElem = i(g.shift())), (k.style = k.modElem.style);
      for (d = e.length, c = 0; d > c; c++)
        if (
          ((m = e[c]),
          (v = k.style[m]),
          l(m, '-') && (m = a(m)),
          k.style[m] !== t)
        ) {
          if (o || r(s, 'undefined')) return u(), 'pfx' == n ? m : !0;
          try {
            k.style[m] = s;
          } catch (h) {}
          if (k.style[m] != v) return u(), 'pfx' == n ? m : !0;
        }
      return u(), !1;
    }
    function g(e, n, t, s, o) {
      var i = e.charAt(0).toUpperCase() + e.slice(1),
        l = (e + ' ' + T.join(i + ' ') + i).split(' ');
      return r(n, 'string') || r(n, 'undefined')
        ? v(l, n, s, o)
        : ((l = (e + ' ' + N.join(i + ' ') + i).split(' ')), f(l, n, t));
    }
    function h(e, n, r) {
      return g(e, t, t, n, r);
    }
    var C = [],
      S = [],
      w = {
        _version: '3.6.0',
        _config: {
          classPrefix: '',
          enableClasses: !0,
          enableJSClass: !0,
          usePrefixes: !0,
        },
        _q: [],
        on: function(e, n) {
          var t = this;
          setTimeout(function() {
            n(t[e]);
          }, 0);
        },
        addTest: function(e, n, t) {
          S.push({ name: e, fn: n, options: t });
        },
        addAsyncTest: function(e) {
          S.push({ name: null, fn: e });
        },
      },
      Modernizr = function() {};
    (Modernizr.prototype = w), (Modernizr = new Modernizr());
    var _ = n.documentElement,
      x = 'svg' === _.nodeName.toLowerCase(),
      b = w._config.usePrefixes
        ? ' -webkit- -moz- -o- -ms- '.split(' ')
        : ['', ''];
    w._prefixes = b;
    var P = 'CSS' in e && 'supports' in e.CSS,
      z = 'supportsCSS' in e;
    Modernizr.addTest('supports', P || z);
    var E = 'Moz O ms Webkit',
      T = w._config.usePrefixes ? E.split(' ') : [];
    w._cssomPrefixes = T;
    var N = w._config.usePrefixes ? E.toLowerCase().split(' ') : [];
    w._domPrefixes = N;
    var j = { elem: i('modernizr') };
    Modernizr._q.push(function() {
      delete j.elem;
    });
    var k = { style: j.elem.style };
    Modernizr._q.unshift(function() {
      delete k.style;
    }),
      (w.testAllProps = g),
      (w.testAllProps = h),
      Modernizr.addTest('cssfilters', function() {
        if (Modernizr.supports) return h('filter', 'blur(2px)');
        var e = i('a');
        return (
          (e.style.cssText = b.join('filter:blur(2px); ')),
          !!e.style.length && (n.documentMode === t || n.documentMode > 9)
        );
      }),
      s(),
      o(C),
      delete w.addTest,
      delete w.addAsyncTest;
    for (var A = 0; A < Modernizr._q.length; A++) Modernizr._q[A]();
    e.Modernizr = Modernizr;
  })(window, document);
  /* eslint-enable */

  // create insignificant unique id
  const uniqId = function() {
    return (
      '_' +
      Math.random()
        .toString(36)
        .substr(2, 9)
    );
  };

  function draw(img, image, figure, topper) {
    const id = uniqId();
    let node;
    if (topper) {
      node = `<canvas class="desat-canvas-fallback" id="${id}" height="${$(
        figure,
      ).width()}" width="${$(figure).width()}"></canvas>`;
    } else {
      node = `<div class="overlay"></div><canvas class="desat-canvas-fallback" id="${id}" height="${$(
        figure,
      ).width()}" width="${$(figure).width()}"></canvas>`;
    }
    $(figure)
      .find('img')
      .after(node);
    const canvas = document.getElementById(id);

    // centers image and mimics size to canvas contain
    const scale = Math.max(
      canvas.width / img.width,
      canvas.height / img.height,
    );
    // get the top left position of the image
    const x = canvas.width / 2 - (img.width / 2) * scale;
    const y = canvas.height / 2 - (img.height / 2) * scale;

    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, x, y, img.width * scale, img.height * scale);
    img.style.display = 'none';
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);

    /* eslint-disable */
    const data = imageData.data;
    /* eslint-enable */

    // desaturation through pixel manipulation
    for (let i = 0; i < data.length; i += 4) {
      const avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
      data[i] = avg; // red
      data[i + 1] = avg; // green
      data[i + 2] = avg; // blue
    }
    // apply image data to canvas
    ctx.putImageData(imageData, 0, 0);
  }

  function createCanvas(image, figure, topper) {
    // handles non-lazy vs lazy images
    let src = '';
    if (!$(image).attr('data-src')) {
      src = $(image).attr('src');
    } else {
      src = $(image).attr('data-src');
    }

    // create image instance
    const img = new Image();
    img.src = src;
    img.onload = function() {
      draw(this, image, figure, topper);
    };
  }

  // check if supports cssfilters
  if ($('html').hasClass('no-supports no-cssfilters')) {
    const $desat = $('.desat');
    if ($desat.length > 0) {
      $desat.each(function() {
        const $this = $(this);
        const $thisImg = $this.find('img');
        $thisImg.hide();

        // test for topper
        let topper = false;
        if ($this.hasClass('topper-image')) {
          topper = true;
        }
        createCanvas($thisImg, $this, topper);
      });
    }
  }
});
